import Plugin from '../Plugin'

import StorefrontClient from '@engine/storefront/StorefrontClient'

export default class Storefront extends Plugin {

    constructor(network) {
        super(network)

        if (this.game.storefront instanceof StorefrontClient) {
            this.client = this.game.storefront
        } else {
            this.client = new StorefrontClient(this.game, this.network)
            this.game.storefront = this.client
        }

        this.events = {
            'load_player': this.handleLoadPlayer.bind(this),
            'storefront_data': this.handleStorefrontData.bind(this),
            'storefront_error': this.handleStorefrontError.bind(this)
        }
    }

    handleLoadPlayer() {
        this.client.handleLoadPlayer()
    }

    handleStorefrontData(payload) {
        this.client.upsertStore(payload)
    }

    handleStorefrontError(payload) {
        this.client.emitError(payload)
    }

}
